import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function AboutPage() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'bob体育',
    url: 'https://www.bob-sports.com',
    description: 'bob体育是专业的在线体育娱乐平台，提供足球、篮球、网球等全球顶级赛事竞猜服务，实时赔率更新，多种投注方式任你选择。',
    foundingDate: '2016',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-8888',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
      areaServed: 'CN',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.bob-sports.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  const milestones = [
    { year: '2016', title: '品牌创立', desc: 'bob体育正式成立，获得国际博彩运营牌照，开启专业体育娱乐服务之路。' },
    { year: '2018', title: '全球化布局', desc: '业务扩展至亚洲、欧洲等多个市场，成为业内知名的体育竞猜平台。' },
    { year: '2020', title: '技术升级', desc: '全面升级赔率系统和交易引擎，引入AI数据分析，实时赔率更新速度行业领先。' },
    { year: '2022', title: '用户突破', desc: '全球注册用户突破300万，成为最受欢迎的在线体育娱乐平台之一。' },
    { year: '2024', title: '移动优先', desc: '推出全新APP产品，实现多端无缝体验，移动端用户占比超过70%。' },
    { year: '2026', title: '行业领先', desc: '全球注册用户突破500万，覆盖200+体育赛事，持续引领行业创新发展。' },
  ];

  const values = [
    { icon: 'ri-shield-star-line', title: '安全为本', desc: '采用国际领先的加密技术和风控体系，全方位保障用户信息与资金安全。持有正规博彩牌照，合规运营。' },
    { icon: 'ri-scales-line', title: '公平公正', desc: '所有赛事赔率公开透明，严格遵守行业规范，确保每一位用户的合法权益。' },
    { icon: 'ri-rocket-line', title: '创新驱动', desc: '持续投入技术研发，不断优化产品体验，为用户提供更快、更稳、更智能的竞猜服务。' },
    { icon: 'ri-heart-line', title: '用户至上', desc: '以用户需求为核心，7×24小时客服全程护航，用心服务每一位bob体育用户。' },
  ];

  return (
    <>
      <SchemaOrg data={orgSchema} />
      <SchemaOrg data={breadcrumbSchema} />
      <Navbar />

      <Breadcrumb items={[{ label: '关于我们' }]} />

      <main className="bg-background-50">
        {/* Hero */}
        <section className="relative h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Professional%20sports%20headquarters%20building%20with%20modern%20architecture%2C%20dramatic%20lighting%2C%20premium%20corporate%20aesthetic%2C%20dark%20background%20with%20warm%20golden%20accents%2C%20abstract%20artistic%20style%2C%20no%20text%20no%20logos&width=1800&height=600&seq=about-bob-hero&orientation=landscape"
            alt="bob体育品牌"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-white mb-3">关于 bob体育</h1>
            <p className="text-sm md:text-base text-white/70 max-w-lg mx-auto">专业在线体育娱乐平台，值得信赖的赛事竞猜伙伴</p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    <strong className="text-foreground-900">bob体育</strong>是一家专注于在线体育娱乐服务的国际化平台，自2016年创立以来，始终致力于为全球体育爱好者提供专业、安全、便捷的赛事竞猜体验。
                  </p>
                  <p>
                    平台覆盖<strong className="text-foreground-900">足球、篮球、网球、电竞</strong>等200余项全球顶级体育赛事，拥有实时赔率更新系统，确保用户始终获得最具竞争力的赔率。无论是欧洲五大联赛、NBA、大满贯网球赛事，还是LOL、DOTA2等电竞盛宴，bob体育都能满足您的竞猜需求。
                  </p>
                  <p>
                    bob体育持有国际正规博彩运营牌照，采用<strong className="text-foreground-900">银行级加密技术</strong>和先进的资金管理体系，全程保障用户信息安全与资金安全。平台支持多种主流支付方式，存取款便捷高效。
                  </p>
                  <p>
                    我们拥有<strong className="text-foreground-900">超过500万全球注册用户</strong>，7×24小时专业客服团队随时为用户提供服务。bob体育始终秉持"安全为本、公平公正、创新驱动、用户至上"的核心价值观，致力于成为全球最值得信赖的在线体育娱乐平台。
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {values.map((v) => (
                  <div key={v.title} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                    <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                      <i className={`${v.icon} text-lg text-accent-600`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{v.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{v.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">发展历程</h2>
              <p className="text-sm text-foreground-500 mt-2">十年深耕，持续引领行业发展</p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {milestones.map((m) => (
                <div key={m.year} className="bg-background-50 rounded-xl p-5 border border-background-200/70 text-center">
                  <span className="text-2xl font-heading font-bold text-accent-500">{m.year}</span>
                  <h3 className="text-sm font-semibold text-foreground-900 mt-2 mb-1.5">{m.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{m.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-12 md:py-16">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">品牌信誉</h2>
              <p className="text-sm text-foreground-500 mt-2">行业认可，用户信赖</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-xl text-primary-500"></i>
                </div>
                <div className="text-2xl font-heading font-bold text-primary-500 mb-1">国际牌照</div>
                <p className="text-xs text-foreground-500">持有正规国际博彩运营牌照，合法合规经营</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-lock-line text-xl text-primary-500"></i>
                </div>
                <div className="text-2xl font-heading font-bold text-primary-500 mb-1">SSL加密</div>
                <p className="text-xs text-foreground-500">256位SSL加密技术，全方位保护用户数据安全</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-team-line text-xl text-primary-500"></i>
                </div>
                <div className="text-2xl font-heading font-bold text-primary-500 mb-1">500万+用户</div>
                <p className="text-xs text-foreground-500">全球注册用户信赖之选，口碑见证实力</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-award-line text-xl text-primary-500"></i>
                </div>
                <div className="text-2xl font-heading font-bold text-primary-500 mb-1">行业奖项</div>
                <p className="text-xs text-foreground-500">多项行业大奖认可，最佳体育娱乐平台</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">联系我们</h2>
              <p className="text-sm text-foreground-500 mt-2">bob体育7×24小时客服团队随时为您服务</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-3xl mx-auto">
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-phone-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服热线</h3>
                <p className="text-sm text-accent-600 font-medium">400-888-8888</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-sm text-accent-600 font-medium">service@bob-sports.com</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-customer-service-2-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线客服</h3>
                <p className="text-sm text-accent-600 font-medium">7×24小时在线</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}